import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import SearchHeroSection from '../components/CollegeFinder/SearchHeroSection';
import FeaturedColleges from '../components/CollegeFinder/FeaturedColleges';
import AdBanner from '../components/CollegeFinder/AdBanner';
import NewsUpdates from '../components/CollegeFinder/NewsUpdates';
import CounselorSection from '../components/CollegeFinder/CounselorSection';
import PopularSearches from '../components/CollegeFinder/PopularSearches';
import CollegeSearchResults from '../components/CollegeFinder/CollegeSearchResults';
import './CollegeFinder.css';

const CollegeFinder = () => {
  const [searchParams] = useSearchParams();
  // Check if we are in search mode (either via ?search=true flag or if a search query ?q exists)
  const isSearchMode = searchParams.get('search') === 'true' || !!searchParams.get('q');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isSearchMode]);

  return (
    <div className="college-finder-page">
      <Navbar />
      
      {/* Search Hero Section */}
      <SearchHeroSection isSearchMode={isSearchMode} />
      
      {isSearchMode ? (
        <>
          {/* Search Mode Content */}
          <AdBanner />
          <CollegeSearchResults />
        </>
      ) : (
        <>
          {/* Default Content */}
          <FeaturedColleges />
          <AdBanner />
        </>
      )}
      
      {/* News & Updates and Counselor Section - Order swaps in search mode */}
      {isSearchMode ? (
        <>
          <CounselorSection />
          <NewsUpdates />
        </>
      ) : (
        <>
          <NewsUpdates />
          <CounselorSection />
        </>
      )}
      
      {/* Popular Searches Section - Only visible in default mode */}
      {!isSearchMode && <PopularSearches />}
      
      <Footer />
    </div>
  );
};

export default CollegeFinder;
